import React, { Component } from 'react';
import { Permissions } from './Permissions';

const Authorization = roles =>
    (WrappedComponent) => {
        return class withAuthorization extends Component {
            constructor(props) {
                super(props);
                this.isAllowed = this.isAllowed.bind(this);
            }

            isAllowed(roles) {
                return Permissions.hasAuthorization(roles);
            }

            render() {
                if (this.isAllowed(roles)) {
                    return (<WrappedComponent {...this.props} />);
                }
                else {
                    return (<h1>Permissão negada!</h1>);
                }
            }
        }
    }

export default Authorization;